import React, { useEffect, useRef, useState } from "react";
import "./SpaServices.css";

/**
 * Recover. Rejuvenate. Revive — landing section
 * - Clean, airy layout
 * - Quote + intro copy
 * - 3 service cards with images
 * - Fully responsive
 */

export default function SpaServices() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

const cards = [
  {
    title: "Therapeutic Massage",
    img: "./aboutimage-one.jpg",
    text: "Experience deep relaxation and muscle relief with a variety of therapeutic techniques including Swedish and deep tissue massage. Each session is customized to relieve tension, improve circulation, and support overall healing.",
  },
  {
    title: "Specialty Treatments",
    img: "./seated.jpg",
    text: "Explore specialized services such as cupping therapy, seated chair massage, and targeted muscle treatments. These services are designed to improve mobility, release deep tension, and enhance recovery.",
  },
  {
    title: "Relaxation & Wellness",
    img: "./animal.jpg",
    text: "Promote balance and well-being with calming therapies including relaxation massage and animal massage. These treatments help reduce stress, increase blood flow, and support natural healing for both body and mind.",
  },
];
  return (
    <main className="spa" ref={sectionRef}>
      {/* Background Elements */}
      <div className="spa__bg-elements" aria-hidden="true">
        <div className="spa__bg-shape spa__bg-shape--1"></div>
        <div className="spa__bg-shape spa__bg-shape--2"></div>
        <div className="spa__bg-shape spa__bg-shape--3"></div>
      </div>

      <div className="spa__container">
        {/* Heading */}
        <header className={`spa__head ${isVisible ? 'is-visible' : ''}`}>
          <div className="spa__ornament" aria-hidden="true">
            <div className="spa__ornament-line"></div>
            <div className="spa__ornament-dot"></div>
            <div className="spa__ornament-line"></div>
          </div>
          <h1 className="spa__title">
            <span className="spa__title-line">Relax. Restore.</span>
            <span className="spa__title-line spa__title-line--accent">Renew.</span>
          </h1>
          <div className="spa__divider" aria-hidden="true">
            <div className="spa__divider-line"></div>
            <div className="spa__divider-line"></div>
          </div>
        </header>

        {/* Intro row - Now with paragraph on top, quote below */}
        <section className={`spa__intro ${isVisible ? 'is-visible' : ''}`}>
          <div className="spa__copy">
            <p>
At A Peaceful Retreat, I believe true wellness begins with mindful care and personalized attention. With over 28 years of experience in the massage therapy industry, I offer a range of techniques, including cupping, deep tissue, Swedish, seated chair, and even animal massage. With expertise and dedication to providing exceptional care, I strive to help clients achieve optimal relaxation and wellness. Each visit is thoughtfully designed to help you disconnect from daily stresses and reconnect with your inner peace.
            </p>
          </div>
          
          <blockquote className="spa__quote">
            <div className="spa__quote-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" width="24" height="24">
                <path d="M4.583 17.321C3.553 16.227 3 15 3 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 0 1-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179zm10 0C13.553 16.227 13 15 13 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 0 1-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179z" fill="currentColor"/>
              </svg>
            </div>
            <p>"A sanctuary where every treatment is crafted to make you feel uniquely special and completely renewed"</p>
            <cite>— Angela Oaks, Founder</cite>
          </blockquote>
        </section>

        {/* Cards */}
        <section className={`spa__grid ${isVisible ? 'is-visible' : ''}`}>
          {cards.map((card, index) => (
            <article 
              className={`card ${isVisible ? 'is-visible' : ''}`} 
              key={index}
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              {/* Card Glow Effect */}
              <div className="card__glow" aria-hidden="true"></div>
              
              {/* Card Corners */}
              <div className="card__corner card__corner--tl" aria-hidden="true"></div>
              <div className="card__corner card__corner--br" aria-hidden="true"></div>

              <figure className="card__media">
                <div className="card__image-frame" aria-hidden="true"></div>
                <img src={card.img} alt={card.title} loading="lazy" />
                <div className="card__image-overlay" aria-hidden="true"></div>
              </figure>
              <div className="card__body">
                <h3 className="card__title">{card.title}</h3>
                <p className="card__text">{card.text}</p>
              </div>
            </article>
          ))}
        </section>
      </div>
    </main>
  );
}